export default {
  data() {
    return {
      _rf_elmToRestore: null
    }
  },
  mounted() {
    this._rf_elmToRestore = document.activeElement;
  },
  beforeDestroy() {
    this._rf_elmToRestore && this._rf_elmToRestore.focus();
  },
}